<template>
  <div v-if="visible">
    <a class="context__menu-item-link" @click="$refs.modal.show()">
      <i class="context__menu-item-icon iconoir-git-fork"></i>
      Dependencia de fecha
    </a>
    <DependenciaFechasModal ref="modal" :table="table" />
  </div>
</template>

<script>
/**
 * "Dependencia de fecha" en el menú de una tabla. Enterprise la ofrecía con
 * candado; esta es la propia (extras_mg/fechas). Sale a quien puede cambiar
 * las reglas de la tabla.
 */
import DependenciaFechasModal from '@extras_mg/components/DependenciaFechasModal'

export default {
  name: 'DependenciaFechasItem',
  components: { DependenciaFechasModal },
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
  },
  computed: {
    visible() {
      return this.$hasPermission(
        'database.table.field_rules.set_field_rules',
        this.table,
        this.database.workspace.id
      )
    },
  },
}
</script>
